var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "page", attrs: { role: "main" } }, [
    _c("div", { staticClass: "o-wrapper" }, [
      _c(
        "div",
        {
          staticClass:
            "o-grid--center u-m-t4 u-width-5/8 u-width-10/12@l u-width-full@m u-center",
        },
        [
          _c("h1", [_vm._v(_vm._s(_vm.code) + " Error")]),
          _vm._v(" "),
          _c("p", { staticClass: "u-m-t2" }, [_vm._v(_vm._s(_vm.reason))]),
          _vm._v(" "),
          _c("p", { staticClass: "u-text-meta" }, [
            _vm._v("Error page: " + _vm._s(_vm.from)),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }